/**
 * Evita que las imágenes, videos y logos del sitio se arrastren o se descarguen
 * con clic derecho / pulsación larga. Es disuasivo: no impide una captura de pantalla.
 */
const PROTECTED = "img, video, picture, svg image, canvas";

const isProtected = (target: EventTarget | null) =>
  target instanceof Element && target.closest(PROTECTED) !== null;

export const protectMedia = () => {
  const block = (e: Event) => {
    if (isProtected(e.target)) e.preventDefault();
  };
  document.addEventListener("contextmenu", block);
  document.addEventListener("dragstart", block);

  // Videos: sin menú de descarga ni imagen-en-imagen.
  const hardenVideos = (root: ParentNode) => {
    root.querySelectorAll("video").forEach((video) => {
      video.setAttribute("controlsList", "nodownload noremoteplayback");
      video.setAttribute("disablePictureInPicture", "");
      video.setAttribute("draggable", "false");
    });
    root.querySelectorAll("img").forEach((img) => img.setAttribute("draggable", "false"));
  };
  hardenVideos(document);
  new MutationObserver((records) => {
    for (const record of records) {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          if (node.matches("img, video")) hardenVideos(node.parentElement ?? document);
          else hardenVideos(node);
        }
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
};
